enum LogicalOperator {
    AND = 'and',
    OR = 'or',
}

export default LogicalOperator;
